import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SideMenu from "../SideBar/Sidemenu";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import UrlResolver from "../../utils/UrlResolver";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const MainLayout = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [activeSubMenu, setActiveSubMenu] = useState({
    entity: null,
    message: null,
    endpoint: null,
    alerts: null,
    other: null,
  });
  const [openMenus, setOpenMenus] = useState([]);
  const location = useLocation();
  const { pathname } = location;
  const menuMapping = {
    "/maintainentity": "entity",
    "/entity_types": "entity",
    "/base_company": "entity",
    "/message_types": "message",
    "/routing_status": "message",
    "/staus_code": "message",
    "/mapping_stream": "message",
    "/message_routing": "message",
    "/Source_Endpoint": "endpoint",
    "/endpoint_type": "endpoint",
    "/handling_tracks": "alerts",
    "/categories": "alerts",
    "/alert_types": "alerts",
    "/latency_types": "other",
    "/log_records": "other",
    "/stats_Tbnumber":"other",
     "/Statistics":"other"
  };

  const handleDrawerOpen = () => {
    setOpen(true);
    const activeSubmenu = Object.keys(menuMapping).find((submenuPath) =>
      pathname.includes(submenuPath)
    );

    if (activeSubmenu) {
      const parentMenu = menuMapping[activeSubmenu];

      setActiveSubMenu({
        ...activeSubMenu,
        [parentMenu]: 0,
      });
      setOpenMenus([parentMenu]);
    }
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Drawer variant="permanent" open={open}>
        <div className="imgdiv">
          {open && (
            <div className="logoImgContainer" onClick={handleDrawerClose}>
              <img
                src={UrlResolver(`assets/Images/Logo_White.svg`)}
                alt="Logo"
                className="logoImg"
                onClick={handleDrawerClose}
              />
            </div>
          )}
          <IconButton onClick={open ? handleDrawerClose : handleDrawerOpen}>
            {!open && (
              <div className="logoImgContainer" onClick={handleDrawerOpen}>
                <img
                  src={UrlResolver(`assets/Images/Logo_White.svg`)}
                  alt="Logo"
                  className="logoImg"
                />
              </div>
            )}
          </IconButton>
        </div>
        <SideMenu
          open={open}
          setOpen={setOpen}
          activeSubMenu={activeSubMenu}
          setActiveSubMenu={setActiveSubMenu}
          openMenus={openMenus}
          setOpenMenus={setOpenMenus}
          handleDrawerOpen={handleDrawerOpen}
          menuMapping={menuMapping}
        />
      </Drawer>
      <Box sx={{ width: "calc(100% - 0px)", overflow: "auto" }}>
        <Outlet />
      </Box>
    </Box>
  );
};
